<template>
  <div class="">
    <v-card class="pa-6">
      <v-card-title class="mb-5">
        Bookings Report
      </v-card-title>
      <v-card-title>
        <v-icon
          class="mr-2"
        >
          mdi-filter-outline
        </v-icon> Filter

      </v-card-title>
      <v-card-text>
        <v-row class="pa-0">
          <v-col cols="12" md="3">
            <v-select
              v-model="shipmentType"
              :items="shipmentTypes"
              menu-props="auto"
              label="Shipment Type"
              item-text="name"
              item-value="id"
              hide-details
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              v-model="menuStartDate"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  label="Start Date"
                  append-icon="mdi-calendar"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @input="menuStartDate = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="3">
            <v-menu
              v-model="menuEndDate"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="endDate"
                  label="End Date"
                  append-icon="mdi-calendar"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                @input="menuEndDate = false"
                :min="startDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-2"
                fab
                depressed
                color="primary"
                v-on="on"
                @click="doPrint()"
              >
                <v-icon dark>
                  mdi-printer
                </v-icon>
              </v-btn>
            </template>
            <span>Print</span>
          </v-tooltip>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import printJS from 'print-js'

  export default {
    name: 'RptBookings',
    data() {
      return {
        menuStartDate: false,
        menuEndDate: false,
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
        shipmentType: '',
        shipmentTypes: [
          { id: '', name: 'All' },
          { id: 1, name: 'Sea' },
          { id: 2, name: 'Air Freight' }
        ]
      }
    },
    computed: {
      ...mapGetters(['formatNumberAmount', 'formatNumber', 'getApiUrl'])
    },
    watch: {
    },
    methods: {
      doPrint () {
        const currentDate = new Date();
        const unixTimestamp = Math.floor(currentDate.getTime() / 1000)

        let params = []
        params.push('start_date'+'='+this.startDate)
        params.push('end_date'+'='+this.endDate)
        params.push('v'+'='+unixTimestamp)
        if (this.shipmentType !== '') params.push('shipment_type'+'='+this.shipmentType)

        window.open(this.getApiUrl+'/api/reports/bookings?'+params.join('&'), '_newtab');

        // printJS(this.getApiUrl+'/api/reports/bookings?'+params.join('&'));
      },
    },
    mounted() {
    },
    components: {
    },
  }
</script>
